import {
  Document,
  Image,
  Link,
  Page,
  Path,
  Rect,
  Svg,
  Text,
  View,
  pdf,
} from "@react-pdf/renderer";
import {
  EnumPoljaEvidencije,
  IAddress,
  ILocalStorage,
  IRecordPointClass,
} from "../../../../redux/interfaces";
import {
  GroupedData,
  Record,
  getAllEvdData,
  openListaEvidencijaPdfBlobInNewTab,
  preferListaEvidencijaPdfInlineTab,
} from "./ListaEvidencijaPdfDocument";
import { ITextFields, styles } from "./Tables";
import {
  TableFooterPdf,
  TableRichDescriptionPdf,
} from "./Pdf/SveEvidencije/SveEvidencije";
import {
  TableRowCIPOEvdListaEvidencija,
  TableRowCIPOEvdListaEvidencijaHeader,
} from "./Pdf/CIPOPdf/CIPOPdfListaEvidencija";
import {
  TableRowCIPPEvdListaEvidencija,
  TableRowCIPPEvdListaEvidencijaHeader,
} from "./Pdf/CIPPPdf/CIPPPdfListaEvidencija";
import {
  TableRowDeratizacijaEvdListaEvidencija,
  TableRowDeratizacijaEvdListaEvidencijaHeader,
} from "./Pdf/DeratizacijaPdf/DeratizacijaPdfListaEvidencija";
import {
  TableRowDeratizacijaKontrolaEvdListaEvidencija,
  TableRowDeratizacijaKontrolaEvdListaEvidencijaHeader,
} from "./Pdf/DeratizacijaKontrolaPdf/DeratizacijaKontrolaPdfListaEvidencija";
import {
  TableRowDeratizacijaKorekcijaEvdListaEvidencija,
  TableRowDeratizacijaKorekcijaEvdListaEvidencijaHeader,
} from "./Pdf/DeratizacijaKorekcijaPdf/DeratizacijaKorekcijaPdfListaEvidencija";
import {
  TableRowDezSrEvdListaEvidencija,
  TableRowDezSrEvdListaEvidencijaHeader,
} from "./Pdf/DezSrPdf/DezSrPdfListaEvidencija";
import {
  TableRowDezinfekcijaEvdListaEvidencija,
  TableRowDezinfekcijaEvdListaEvidencijaHeader,
} from "./Pdf/DezinfekcijaPdf/DezinfekcijaPdfListaEvidencija";
import {
  TableRowDezinsekcijaEvdListaEvidencija,
  TableRowDezinsekcijaEvdListaEvidencijaHeader,
} from "./Pdf/DezinsekcijaPdf/DezinsekcijaPdfListaEvidencija";
import {
  TableRowDezinsekcijaKontrolaEvdListaEvidencija,
  TableRowDezinsekcijaKontrolaEvdListaEvidencijaHeader,
} from "./Pdf/DezinsekcijaKontrolaPdf/DezinsekcijaKontrolaPdfListaEvidencija";
import {
  TableRowDezinsekcijaKorekcijaEvdListaEvidencija,
  TableRowDezinsekcijaKorekcijaEvdListaEvidencijaHeader,
} from "./Pdf/DezinsekcijaKorekcijaPdf/DezinsekcijaKorekcijaPdfListaEvidencija";
import {
  TableRowDobavljaciEvdListaEvidencija,
  TableRowDobavljaciEvdListaEvidencijaHeader,
} from "./Pdf/DobavljaciPdf/DobavljaciPdfListaEvidencija";
import {
  TableRowDostavaEvdListaEvidencija,
  TableRowDostavaEvdListaEvidencijaHeader,
} from "./Pdf/DostavaPdf/DostavaPdfListaEvidencija";
import {
  TableRowEduEvdListaEvidencija,
  TableRowEduEvdListaEvidencijaHeader,
} from "./Pdf/EduPdf/EduPdfListaEvidencija";
import {
  TableRowMolEvdListaEvidencija,
  TableRowMolEvdListaEvidencijaHeader,
} from "./Pdf/MolerskiRadoviPdf/MolerskiRadoviPdfListaEvidencija";
import {
  TableRowOpremaEvdListaEvidencija,
  TableRowOpremaEvdListaEvidencijaHeader,
} from "./Pdf/OpremaPdf/OpremaPdfListaEvidencija";
import {
  TableRowOtpadEvdListaEvidencija,
  TableRowOtpadEvdListaEvidencijaHeader,
} from "./Pdf/OtpadPdf/OtpadPdfListaEvidencija";
import {
  TableRowPrijemEvdListaEvidencija,
  TableRowPrijemEvdListaEvidencijaHeader,
} from "./Pdf/PrijemPdf/PrijemPdfListaEvidencija";
import {
  TableRowSanitarniEvdListaEvidencija,
  TableRowSanitarniEvdListaEvidencijaHeader,
} from "./Pdf/SanitarniPdf/SanitarniPdfListaEvidencija";
import {
  TableRowTemperaturaEvdListaEvidencija,
  TableRowTemperaturaEvdListaEvidencijaHeader,
} from "./Pdf/TemperaturaPdf/TemperaturaPdfListaEvidencija";
import {
  TableRowTemperaturaKKTProizvodiEvdListaEvidencija,
  TableRowTemperaturaKKTProizvodiEvdListaEvidencijaHeader,
} from "./Pdf/TemperaturaKKTProizvodiPdf/TemperaturaKKTProizvodiPdfListaEvidencija";
import {
  TableRowTemperaturaOgranicenaEvdListaEvidencija,
  TableRowTemperaturaOgranicenaEvdListaEvidencijaHeader,
  TableTemperaturaOgranicenaListaEvidencijaHeader,
} from "./Pdf/TemperaturaOgranicenaPdf/TemperaturaOgranicenaPdfListaEvidencija";
import {
  TableRowTemperaturaOgranicenaKKTEvdListaEvidencija,
  TableRowTemperaturaOgranicenaKKTEvdListaEvidencijaHeader,
  TableTemperaturaOgranicenaKKTListaEvidencijaHeader,
} from "./Pdf/TemperaturaOgranicenaKKTPdf/TemperaturaOgranicenaKKTPdfListaEvidencija";
import { formatDate, getMonthBoundaries } from "../helpers/FormatDate";
import {
  getAddress,
  getAdekvatnoPrikupljen,
  getBrojRacuna,
  getCilj,
  getDatumObuke,
  getDokument,
  getEarliestCreatedAt,
  getExtraDate,
  getExtraVrijeme,
  getExtraVrijemeKorekcije,
  getIdTax,
  getImeIPrezime,
  getKolicina,
  getNapomena,
  getNaziv,
  getOpis,
  getOpisKontrole,
  getOpisKorekcije,
  getPdvTax,
  getPhoneNumber,
  getPosiljalac,
  getPotpis,
  getPrimalac,
  getPrimjedba,
  getPrimjena,
  getProdutType,
  getProizvod,
  getRadnoMjesto,
  getRichDescription,
  getSlikaDeklaracije,
  getStanjeKontrole,
  getStanjeKorekcije,
  getTema,
  getTemperatura,
  getTipEvidencije,
  getUposlenik,
  getUpustvoZaUpotrebu,
  getVaziDo,
  getVaziOd,
  getVrsta,
  getdatumKorekcije,
  getdozvoljenaTempMax,
  getdozvoljenaTempMaxKorekcije,
  getdozvoljenaTempMin,
  getdozvoljenaTempMinKorekcije,
  getdozvoljenoOdstupanje,
  getimePrezimeKorekcije,
  getizvrsilacObuke,
  getjedinicaMjere,
  getkorektivnaMjera,
  getmjestoObuke,
  getocitanaTemperatura,
  getocitanaTemperaturaKorekcije,
  getopisMjeereKorekcije,
  getpotpisIzvrsiocaKorekcije,
  getpotpisPosiljalac,
  getpotpisPrimalac,
  getverifikacijaEdukatoraPotpis,
  getverifikacijaEfikasnosti,
  getverifikacijaPrisustvaPotpis,
} from "../helpers/GetRecordPointClass";

import PageNumber from "./PageNumber";
import React from "react";
import { TableEDUMainHeader } from "./Pdf/EduPdf/EduPdfListaDefinisanihTacaka";
import logo from "../../../../assets/images/logo-light.png";

const CheckboxIcon = ({ checked }: { checked: boolean }) => (
  <Svg width={12} height={12} viewBox="0 0 24 24">
    <Rect
      x={3}
      y={3}
      width={18}
      height={18}
      rx={2}
      ry={2}
      stroke="#1f2a44"
      strokeWidth={2}
      fill="none"
    />
    {checked && (
      <Path d="M7 12l3 3 7-7" stroke="#1f2a44" strokeWidth={2} fill="none" />
    )}
  </Svg>
);

export interface IPDFBranch {
  name: string;
  address: IAddress;
}

interface PdfDocumentProps {
  data: IRecordPointClass[];
  branch: IPDFBranch;
  evidencija: string;
  title: string;
  res: ITextFields;
  recordField: EnumPoljaEvidencije;
  startDate: Date;
  endDate: Date;
  richDescription: string;
}

// Liste Evidencija
const PdfDocument: React.FC<PdfDocumentProps> = ({
  data,
  branch,
  evidencija,
  res,
  recordField,
  startDate,
  endDate,
  richDescription,
}) => {
  const convertedArray = data.flatMap((item) => {
    const evdData = getAllEvdData(item);
    return evdData.map((evd) => {
      const extraDatum = getExtraDate(item, evd.id, evd.evdProperty);

      return {
        naziv: item.name ? item.name : "",
        datum: formatDate(getEarliestCreatedAt(item, evd.id)?.toString() || ""),
        brojRacuna: getBrojRacuna(item, evd.id),
        fullname: getImeIPrezime(item, evd.id),
        potpis: getPotpis(item, evd.id),
        tipEvidencije: getTipEvidencije(item, evd.id),
        slikaDeklaracije: getSlikaDeklaracije(item, evd.id),
        opisKorekcije: getOpisKorekcije(item, evd.id),
        opisKontrole: getOpisKontrole(item, evd.id),
        stanjeKontrole: getStanjeKontrole(item, evd.id),
        stanjeKorekcije: getStanjeKorekcije(item, evd.id),
        nazivItem: getNaziv(item, evd.id),
        primjena: getPrimjena(item, evd.id),
        upustvoZaUpotrebu: getUpustvoZaUpotrebu(item, evd.id),
        vrsta: getVrsta(item, evd.id),
        productType: getProdutType(item, evd.id),
        address: getAddress(item, evd.id),
        idTax: getIdTax(item, evd.id),
        pdvTax: getPdvTax(item, evd.id),
        phoneNumber: getPhoneNumber(item, evd.id),
        extraDatum: extraDatum,
        extraVrijeme: getExtraVrijeme(item, evd.id, evd.evdProperty),
        posiljalac: getPosiljalac(item, evd.id),
        potpisPosiljalac: getpotpisPosiljalac(item, evd.id),
        primalac: getPrimalac(item, evd.id),
        potpisPrimalac: getpotpisPrimalac(item, evd.id),
        dokument: getDokument(item, evd.id),
        primjedba: getPrimjedba(item, evd.id),
        korektivnaMjera: getkorektivnaMjera(item, evd.id),
        temperatura: getTemperatura(item, evd.id),
        datumObuke: formatDate(getDatumObuke(item, evd.id)?.toString() || ""),
        cilj: getCilj(item, evd.id),
        izvrsilacObuke: getizvrsilacObuke(item, evd.id),
        mjestoObuke: getmjestoObuke(item, evd.id),
        radnoMjesto: getRadnoMjesto(item, evd.id),
        tema: getTema(item, evd.id),
        verifikacijaEdukatoraPotpis: getverifikacijaEdukatoraPotpis(
          item,
          evd.id,
        ),
        verifikacijaEfikasnosti: getverifikacijaEfikasnosti(item, evd.id),
        verifikacijaPrisustvaPotpis: getverifikacijaPrisustvaPotpis(
          item,
          evd.id,
        ),
        opis: getOpis(item, evd.id),
        uposlenik: getUposlenik(item, evd.id),
        vaziOd: formatDate(getVaziOd(item, evd.id)?.toString() || ""),
        vaziDo: formatDate(getVaziDo(item, evd.id)?.toString() || ""),
        jedinicaMjere: getjedinicaMjere(item, evd.id),
        kolicina: getKolicina(item, evd.id),
        datumKorekcije: getdatumKorekcije(item, evd.id),
        dozvoljenaTempMax: getdozvoljenaTempMax(item, evd.id),
        dozvoljenaTempMaxKorekcije: getdozvoljenaTempMaxKorekcije(item, evd.id),
        dozvoljenaTempMin: getdozvoljenaTempMin(item, evd.id),
        dozvoljenaTempMinKorekcije: getdozvoljenaTempMinKorekcije(item, evd.id),
        dozvoljenoOdstupanje: getdozvoljenoOdstupanje(item, evd.id),
        imePrezimeKorekcije: getimePrezimeKorekcije(item, evd.id),
        ocitanaTemperatura: getocitanaTemperatura(item, evd.id),
        ocitanaTemperaturaKorekcije: getocitanaTemperaturaKorekcije(
          item,
          evd.id,
        ),
        opisMjeereKorekcije: getopisMjeereKorekcije(item, evd.id),
        potpisIzvrsiocaKorekcije: getpotpisIzvrsiocaKorekcije(item, evd.id),
        vrijemeKorekcije: getExtraVrijemeKorekcije(item, evd.id),
        napomena: getNapomena(item, evd.id),
        adekvatnoPrikupljen: getAdekvatnoPrikupljen(item, evd.id),
        proizvod: getProizvod(item, evd.id),
        richDescription: "",
        // Checklist specific fallbacks
        checklistjson: (item as any)?.CheckListEvd?.[evd.id]?.checklistjson,
      };
    });
  });

  // Helper: parse "DD.MM.YYYY" or "DD.MM.YYYY HH:mm" (or with seconds) into Date
  function parseDateTime(dateStr: string): Date {
    if (!dateStr || dateStr.trim() === "") {
      return new Date(0);
    }

    const [datePart, timePartRaw] = dateStr.trim().split(" ");
    if (!datePart) {
      return new Date(0);
    }

    const [day, month, year] = datePart.split(".");
    if (!day || !month || !year) {
      return new Date(0);
    }

    const timePart = timePartRaw || "00:00";
    const [hours, minutes] = timePart.split(":");

    const date = new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10),
      parseInt(hours || "0", 10),
      parseInt(minutes || "0", 10),
    );

    return isNaN(date.getTime()) ? new Date(0) : date;
  }

  function groupByTema(records: Record[]): GroupedData {
    return records.reduce((result, record) => {
      const { tema } = record;
      if (!result[tema]) {
        result[tema] = [];
      }
      result[tema].push(record);
      return result;
    }, {} as GroupedData);
  }

  const groupedData = groupByTema(convertedArray);

  convertedArray.sort((a, b) => {
    // First, compare by record point name ('naziv')
    const nameCompare = (a.naziv || "").localeCompare(b.naziv || "");
    if (nameCompare !== 0) {
      return nameCompare;
    }

    // For records within the same record point, sort by date & time (ascending)
    // Prefer extraDatum (which usually includes time); fall back to datum.
    const dateStrA = a.extraDatum || a.datum || "";
    const dateStrB = b.extraDatum || b.datum || "";

    const dateA = parseDateTime(dateStrA).getTime();
    const dateB = parseDateTime(dateStrB).getTime();

    // Newest first (descending by date/time)
    return dateB - dateA;
  });

  const storedUser = localStorage.getItem("user");
  let person: ILocalStorage | null = null;
  if (storedUser) {
    person = JSON.parse(storedUser);
  }

  let PDFOrientation: "landscape" | "portrait" = "portrait";
  if (
    recordField === EnumPoljaEvidencije.OpremaEvd_V1 ||
    recordField === EnumPoljaEvidencije.OtpadEvd_V1 ||
    recordField === EnumPoljaEvidencije.MolEvd_V1 ||
    recordField === EnumPoljaEvidencije.DezSrEvd_V1 ||
    recordField === EnumPoljaEvidencije.DostavaEvd_V1 ||
    recordField === EnumPoljaEvidencije.EduZapEvd_V1 ||
    recordField === EnumPoljaEvidencije.DobavljacEvd_V1 ||
    recordField === EnumPoljaEvidencije.PrijemRobeEvd_V1 ||
    recordField === EnumPoljaEvidencije.Dezinsekcija_Korekcija_V1 ||
    recordField === EnumPoljaEvidencije.Deratizacija_Korekcije_V1 ||
    recordField === EnumPoljaEvidencije.TemperaturaOgranicenaKKTEvd_V1 ||
    recordField === EnumPoljaEvidencije.TemperaturaOgranicenaEvd_V1 ||
    recordField === EnumPoljaEvidencije.TemperaturaKKTProizvodiEvd_V1
  ) {
    PDFOrientation = "landscape";
  }

  if (recordField === EnumPoljaEvidencije.CheckListEvd_V1) {
    return (
      <Document>
        {convertedArray.map((item, index) => (
          <Page
            key={index}
            size="A4"
            orientation={"portrait"}
            style={styles.page}
          >
            <View style={styles.centeredView}>
              <View style={styles.logoContainer}>
                <Image
                  style={[styles.title, styles.logoImageSmall]}
                  src={logo}
                />
              </View>
              <Text style={styles.title}>{evidencija}</Text>
              <Text style={styles.subtitle}>
                {data[0].RecordTraceConfig?.title
                  ? data[0].RecordTraceConfig?.title.toString()
                  : ""}
                {data[0].RecordTraceConfig?.revizija
                  ? " - " + data[0].RecordTraceConfig?.revizija
                  : ""}
              </Text>
              <Text style={styles.lastSubtitle}>
                {item.naziv || data[0].name}
              </Text>
            </View>

            <View style={styles.header}>
              <Text>{branch.name}</Text>
              <Text>{branch.address.street}</Text>
              <Text>{branch.address.zipCode + " " + branch.address.city}</Text>
              <Text>{branch.address.country}</Text>
            </View>

            <View style={styles.topRightCorner}>
              <Text>{res.odabraniPeriod}</Text>
              <Text style={{ marginTop: 5 }}>
                {getMonthBoundaries(startDate, endDate)}
              </Text>
            </View>

            {/* Overview info (without tacka primjene row) */}
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <View style={styles.tableColHorizontal}>
                  <Text>{res.datum}</Text>
                </View>
                <View style={styles.tableColHorizontal}>
                  <Text>{item.datum}</Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableColHorizontal}>
                  <Text>{res.imeIPrezime}</Text>
                </View>
                <View style={styles.tableColHorizontal}>
                  <Text>{item.fullname}</Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableColHorizontal}>
                  <Text>{res.potpis}</Text>
                </View>
                <View style={styles.tableColHorizontal}>
                  {item.potpis ? (
                    <Image
                      style={[styles.tableCell, styles.signatureImage]}
                      src={item.potpis}
                    />
                  ) : (
                    <Text>-</Text>
                  )}
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.tableColHorizontal}>
                  <Text>{res.dokument}</Text>
                </View>
                <View style={styles.tableColHorizontal}>
                  {item.dokument && (
                    <Link
                      src={item.dokument}
                      style={{ ...styles.tableCell, ...styles.link }}
                    >
                      {res.dokument}
                    </Link>
                  )}
                </View>
              </View>
            </View>

            {/* Checklist items: two columns table with icons, normal font */}
            <View style={styles.table}>
              {(() => {
                const items: any[] = (item as any)?.checklistjson || [];
                if (!items.length) {
                  return (
                    <View style={styles.tableRow}>
                      <View style={styles.tableColHorizontal}>
                        <Text style={styles.tableCell}>-</Text>
                      </View>
                      <View style={styles.tableColHorizontal}>
                        <Text style={styles.tableCell}>-</Text>
                      </View>
                    </View>
                  );
                }
                const rows: any[][] = [];
                for (let i = 0; i < items.length; i += 2) {
                  rows.push([items[i], items[i + 1]]);
                }
                return (
                  <>
                    {rows.map((pair, rIdx) => (
                      <View key={rIdx} style={styles.tableRow} wrap={false}>
                        <View style={styles.tableColHorizontal}>
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CheckboxIcon checked={!!pair[0]?.value} />
                            <Text style={[styles.tableCell, { marginLeft: 6 }]}>
                              {pair[0]?.name || "-"}
                            </Text>
                          </View>
                        </View>
                        <View style={styles.tableColHorizontal}>
                          {pair[1] ? (
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <CheckboxIcon checked={!!pair[1]?.value} />
                              <Text
                                style={[styles.tableCell, { marginLeft: 6 }]}
                              >
                                {pair[1]?.name || "-"}
                              </Text>
                            </View>
                          ) : (
                            <Text style={styles.tableCell}></Text>
                          )}
                        </View>
                      </View>
                    ))}
                  </>
                );
              })()}
            </View>

            {/* Approval/signature footer not needed for Checklist */}
            <PageNumber />
          </Page>
        ))}
        <Page size="A4" orientation={PDFOrientation} style={styles.page}>
          <TableRichDescriptionPdf richDescription={richDescription} />
          <PageNumber />
        </Page>
      </Document>
    );
  }

  return (
    <Document>
      <Page size="A4" orientation={PDFOrientation} style={styles.page}>
        <View style={styles.centeredView}>
          <View style={styles.logoContainer}>
            <Image style={[styles.title, styles.logoImage]} src={logo} />
          </View>
          {recordField === EnumPoljaEvidencije.SanEvd_V1 ? (
            <>
              <Text style={styles.lastSubtitle}>Sanetarna evidencija</Text>
            </>
          ) : (
            <>
              <Text style={styles.title}>{evidencija}</Text>
              <Text style={styles.lastSubtitle}>
                {data[0].RecordTraceConfig?.title
                  ? data[0].RecordTraceConfig?.title.toString()
                  : ""}
                {data[0].RecordTraceConfig?.revizija
                  ? " - " + data[0].RecordTraceConfig?.revizija
                  : ""}
              </Text>
            </>
          )}
        </View>

        {/* Header Section */}
        <View style={styles.header}>
          <Text>{branch.name}</Text>
          <Text>{branch.address.street}</Text>
          <Text>{branch.address.zipCode + " " + branch.address.city}</Text>
          <Text>{branch.address.country}</Text>
        </View>

        {/* TODO: Implement for Selected Month - now only current print  */}
        <View style={styles.topRightCorner}>
          <Text>{res.odabraniPeriod}</Text>
          <Text style={{ marginTop: 5 }}>
            {getMonthBoundaries(startDate, endDate)}
          </Text>
        </View>

        {/* Dezinfekcija */}
        {recordField === EnumPoljaEvidencije.Dezinfekcija_V1 && (
          <View style={styles.table}>
            <TableRowDezinfekcijaEvdListaEvidencijaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              slikaDeklaracije={res.slikaDeklaracije}
              tackaEvidencije={res.tackaPrimjene}
            />
            {convertedArray.map((item, index) => (
              <TableRowDezinfekcijaEvdListaEvidencija
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                slikaDeklaracije={item.slikaDeklaracije}
                slikaRes={res.dokument}
                tackaEvidencije={item.naziv}
              />
            ))}
          </View>
        )}

        {/* Deratizacija */}
        {recordField === EnumPoljaEvidencije.Deratizacija_V1 && (
          <View style={styles.table}>
            <TableRowDeratizacijaEvdListaEvidencijaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              slikaDeklaracije={res.slikaDeklaracije}
              tackaEvidencije={res.tackaPrimjene}
            />
            {convertedArray.map((item, index) => (
              <TableRowDeratizacijaEvdListaEvidencija
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                slikaDeklaracije={item.slikaDeklaracije}
                slikaRes={res.dokument}
                tackaEvidencije={item.naziv}
              />
            ))}
          </View>
        )}

        {/* Dezinsekcija */}
        {recordField === EnumPoljaEvidencije.Dezinsekcija_V1 && (
          <View style={styles.table}>
            <TableRowDezinsekcijaEvdListaEvidencijaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              slikaDeklaracije={res.slikaDeklaracije}
              tackaEvidencije={res.tackaPrimjene}
            />
            {convertedArray.map((item, index) => (
              <TableRowDezinsekcijaEvdListaEvidencija
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                slikaDeklaracije={item.slikaDeklaracije}
                slikaRes={res.dokument}
                tackaEvidencije={item.naziv}
              />
            ))}
          </View>
        )}

        {/* Deratizacija Kontrola */}
        {recordField === EnumPoljaEvidencije.Deratizacija_Kontrole_V1 && (
          <View style={styles.table}>
            <TableRowDeratizacijaKontrolaEvdListaEvidencijaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              opisKontrole={res.opisKontrole}
              stanjeKontrole={res.stanjeKontrole}
              tackaEvidencije={res.tackaPrimjene}
            />
            {convertedArray.map((item, index) => (
              <TableRowDeratizacijaKontrolaEvdListaEvidencija
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                opisKontrole={item.opisKontrole}
                stanjeKontrole={item.stanjeKontrole ? res.da : res.ne}
                tackaEvidencije={item.naziv}
              />
            ))}
          </View>
        )}

        {/* Dezinsekcija Kontrola */}
        {recordField === EnumPoljaEvidencije.Dezinsekcija_Kontrola_V1 && (
          <View style={styles.table}>
            <TableRowDezinsekcijaKontrolaEvdListaEvidencijaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              opisKontrole={res.opisKontrole}
              stanjeKontrole={res.stanjeKontrole}
              tackaEvidencije={res.tackaPrimjene}
            />
            {convertedArray.map((item, index) => (
              <TableRowDezinsekcijaKontrolaEvdListaEvidencija
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                opisKontrole={item.opisKontrole}
                stanjeKontrole={item.stanjeKontrole ? res.da : res.ne}
                tackaEvidencije={item.naziv}
              />
            ))}
          </View>
        )}

        {/* Dezinsekcija Korekcija */}
        {recordField === EnumPoljaEvidencije.Dezinsekcija_Korekcija_V1 && (
          <View style={styles.table}>
            <TableRowDezinsekcijaKorekcijaEvdListaEvidencijaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              opisKorekcije={res.opisKorekcije}
              stanjeKorekcije={res.stanjeKorekcije}
              tackaEvidencije={res.tackaPrimjene}
            />
            {convertedArray.map((item, index) => (
              <TableRowDezinsekcijaKorekcijaEvdListaEvidencija
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                opisKorekcije={item.opisKorekcije}
                stanjeKorekcije={item.stanjeKorekcije}
                tackaEvidencije={item.naziv}
              />
            ))}
          </View>
        )}

        {recordField === EnumPoljaEvidencije.Deratizacija_Korekcije_V1 && (
          <View style={styles.table}>
            <TableRowDeratizacijaKorekcijaEvdListaEvidencijaHeader
              datum={res.datum}
              fullname={res.imeIPrezime}
              potpis={res.potpis}
              opisKorekcije={res.opisKorekcije}
              stanjeKorekcije={res.stanjeKorekcije}
              tackaEvidencije={res.tackaPrimjene}
            />
            {convertedArray.map((item, index) => (
              <TableRowDeratizacijaKorekcijaEvdListaEvidencija
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                opisKorekcije={item.opisKorekcije}
                stanjeKorekcije={item.stanjeKorekcije}
                tackaEvidencije={item.naziv}
              />
            ))}
          </View>
        )}

        {/* Prijem Robe */}
        {recordField === EnumPoljaEvidencije.PrijemRobeEvd_V1 && (
          <View style={styles.table}>
            <TableRowPrijemEvdListaEvidencijaHeader
              datum={res.datum}
              potpisano={res.potpis}
              dokument={res.dokument}
              korektivnaMjera={res.korektivnaMjera}
              temperatura={res.temperatura}
              posiljalac={res.posiljalac}
              potpisPosiljalac={res.potpisPosiljalac}
              primalac={res.primalac}
              primjedba={res.primjedba}
              tackaPrimjene={res.tackaPrimjene}
            />
            {convertedArray.map((item, index) => (
              <TableRowPrijemEvdListaEvidencija
                key={index}
                datum={item.extraDatum || item.datum || ""}
                potpisano={item.potpis}
                dokument={item.dokument}
                slikaRes={res.dokument}
                korektivnaMjera={item.korektivnaMjera}
                temperatura={item.temperatura}
                posiljalac={item.posiljalac}
                potpisPosiljalac={item.potpisPosiljalac}
                primalac={item.primalac}
                primjedba={item.primjedba}
                tackaPrimjene={item.naziv}
              />
            ))}
          </View>
        )}

        {/* Dobavljaci */}
        {recordField === EnumPoljaEvidencije.DobavljacEvd_V1 && (
          <View style={styles.table}>
            <TableRowDobavljaciEvdListaEvidencijaHeader
              naziv={res.naziv}
              productType={res.productType}
              address={res.address}
              idTax={res.idTax}
              pdvTax={res.pdvTax}
              phoneNumber={res.phoneNumber}
            />
            {convertedArray.map((item, index) => (
              <TableRowDobavljaciEvdListaEvidencija
                key={index}
                naziv={item.nazivItem}
                productType={item.productType}
                address={item.address}
                idTax={item.idTax}
                pdvTax={item.pdvTax}
                phoneNumber={item.phoneNumber}
              />
            ))}
          </View>
        )}

        {/* Dez Sr Evd */}
        {recordField === EnumPoljaEvidencije.DezSrEvd_V1 && (
          <View style={styles.table}>
            <TableRowDezSrEvdListaEvidencijaHeader
              naziv={res.naziv}
              primjena={res.primjena}
              slika={res.slika}
              upustvoZaUpotrebu={res.upustvoZaUpotrebu}
              vrsta={res.vrsta}
              tackaEvidencije={res.tackaPrimjene}
            />
            {convertedArray.map((item, index) => (
              <TableRowDezSrEvdListaEvidencija
                key={index}
                naziv={item.nazivItem}
                slika={item.slikaDeklaracije}
                primjena={item.primjena}
                upustvoZaUpotrebu={item.upustvoZaUpotrebu}
                vrsta={item.vrsta}
                tackaEvidencije={item.naziv}
                slikaRes={res.dokument}
              />
            ))}
          </View>
        )}

        {/* Edu Evd */}
        {recordField === EnumPoljaEvidencije.EduZapEvd_V1 &&
          Object.entries(groupedData).map(([tema, records], index) => (
            <View key={index} style={styles.tableHidden}>
              <TableEDUMainHeader
                key={index}
                datumObuke={records[0].datumObuke}
                cilj={records[0].cilj}
                izvrsilacObuke={records[0].izvrsilacObuke}
                mjestoObuke={records[0].mjestoObuke}
                tema={records[0].tema}
                tip={records[0].tipEvidencije}
                datumObukeres={res.datumObuke}
                ciljres={res.cilj}
                izvrsilacObukeres={res.izvrsilacObuke}
                mjestoObukeres={res.mjestoObuke}
                temares={res.tema}
                tipres={res.tip}
              />

              <View key={index} style={styles.table}>
                <TableRowEduEvdListaEvidencijaHeader
                  radnoMjesto={res.radnoMjesto}
                  verifikacijaEdukatoraPotpis={res.verifikacijaEdukatoraPotpis}
                  verifikacijaEfikasnosti={res.verifikacijaEfikasnosti}
                  verifikacijaPrisustvaPotpis={res.verifikacijaPrisustvaPotpis}
                  dokument={res.dokument}
                  imePrezime={res.imePrezime}
                  tackaPrimjene={res.tackaPrimjene}
                />
                {records.map((item, index) => (
                  <TableRowEduEvdListaEvidencija
                    key={index}
                    imePrezime={item.fullname}
                    dokument={item.dokument}
                    radnoMjesto={item.radnoMjesto}
                    verifikacijaEdukatoraPotpis={
                      item.verifikacijaEdukatoraPotpis
                    }
                    verifikacijaEfikasnosti={item.verifikacijaEfikasnosti}
                    verifikacijaPrisustvaPotpis={
                      item.verifikacijaPrisustvaPotpis
                    }
                    slikaRes={res.dokument}
                    tackaPrimjene={item.naziv}
                  />
                ))}
              </View>
            </View>
          ))}

        {/* Sanitarni Evd  */}
        {recordField === EnumPoljaEvidencije.SanEvd_V1 && (
          <View style={styles.table}>
            <TableRowSanitarniEvdListaEvidencijaHeader
              dokument={res.dokument}
              uposlenik={res.uposlenik}
              vaziOd={res.vaziOd}
              vaziDo={res.vaziDo}
            />
            {convertedArray.map((item, index) => (
              <TableRowSanitarniEvdListaEvidencija
                key={index}
                dokument={item.dokument}
                slikaRes={res.dokument}
                uposlenik={item.uposlenik}
                vaziOd={item.vaziOd}
                vaziDo={item.vaziDo}
              />
            ))}
          </View>
        )}

        {/* Dostava Evd  */}
        {recordField === EnumPoljaEvidencije.DostavaEvd_V1 && (
          <View style={styles.table}>
            <TableRowDostavaEvdListaEvidencijaHeader
              datum={res.datum}
              dokument={res.dokument}
              korektivnaMjera={res.korektivnaMjera}
              posiljalac={res.posiljalac}
              potpisPrimalac={res.potpisPrimalac}
              primalac={res.primalac}
              primjedba={res.primjedba}
              ispravnaPosiljka={res.ispravnaPosiljka}
              brojRacuna={res.brojRacuna}
            />
            {convertedArray.map((item, index) => (
              <TableRowDostavaEvdListaEvidencija
                key={index}
                datum={item.extraDatum ? item.extraDatum : ""}
                dokument={item.dokument}
                slikaRes={res.dokument}
                korektivnaMjera={item.korektivnaMjera}
                posiljalac={item.posiljalac}
                potpisPrimalac={item.potpisPrimalac}
                primalac={item.primalac}
                primjedba={item.primjedba}
                ispravnaPosiljka={item.stanjeKontrole ? res.da : res.ne}
                brojRacuna={item.brojRacuna}
              />
            ))}
          </View>
        )}

        {/* Oprema Evd */}
        {recordField === EnumPoljaEvidencije.OpremaEvd_V1 && (
          <View style={styles.table}>
            <TableRowOpremaEvdListaEvidencijaHeader
              tackaEvidencije={res.tackaPrimjene}
              datum={res.datum}
              imePrezime={res.imePrezime}
              izvrsioc={res.izvrsioc}
              opis={res.opis}
              potpis={res.potpis}
              potpisIzvrsioca={res.potpisIzvrsioca}
              tip={res.tip}
            />
            {convertedArray.map((item, index) => (
              <TableRowOpremaEvdListaEvidencija
                tackaPrimjene={item.naziv}
                key={index}
                datum={item.extraDatum}
                potpis={item.potpis}
                fullname={item.fullname}
                izvrsioc={item.izvrsilacObuke}
                opis={item.opis}
                potpisIzvrsioca={item.potpisPosiljalac}
                tip={item.tipEvidencije}
              />
            ))}
          </View>
        )}

        {/* Mol Evd */}
        {recordField === EnumPoljaEvidencije.MolEvd_V1 && (
          <View style={styles.table}>
            <TableRowMolEvdListaEvidencijaHeader
              tackaEvidencije={res.tackaPrimjene}
              datum={res.datum}
              imePrezime={res.kontrolisaoPrimioRadove}
              izvrsioc={res.izvrsioc}
              opis={res.opis}
              potpisIzvrsioca={res.potpisIzvrsioca}
              potpisano={res.potpis}
            />
            {convertedArray.map((item, index) => (
              <TableRowMolEvdListaEvidencija
                key={index}
                imePrezime={item.fullname}
                datum={item.datum}
                izvrsioc={item.izvrsilacObuke}
                opis={item.opis}
                potpisano={item.potpis}
                potpisIzvrsioca={item.potpisPosiljalac}
                tackaPrimjene={item.naziv}
              />
            ))}
          </View>
        )}

        {/* Temperatura Ogranicena Evd */}
        {recordField === EnumPoljaEvidencije.TemperaturaEvd_V1 && (
          <View style={styles.table}>
            <TableRowTemperaturaEvdListaEvidencijaHeader
              resdatum={res.datum}
              resfullname={res.imeIPrezime}
              respotpis={res.potpis}
              restackaPrimjene={res.tackaPrimjene}
              resocitanaTemperatura={res.ocitanaTemperatura}
              reszadovoljenaKontrola={res.zadovoljenaKontrola}
            />
            {convertedArray.map((item, index) => (
              <TableRowTemperaturaEvdListaEvidencija
                key={index}
                resda={res.da}
                resne={res.ne}
                datum={item.extraDatum ? item.extraDatum : ""}
                potpis={item.potpis}
                fullname={item.fullname}
                dozvoljenaTempMax={item.dozvoljenaTempMax}
                dozvoljenaTempMin={item.dozvoljenaTempMin}
                dozvoljenoOdstupanje={item.dozvoljenoOdstupanje}
                ocitanaTemperatura={item.ocitanaTemperatura}
                tackaPrimjene={item.naziv}
              />
            ))}
          </View>
        )}

        {/* Temperatura Ogranicena Evd */}
        {recordField === EnumPoljaEvidencije.TemperaturaOgranicenaEvd_V1 && (
          <TableTemperaturaOgranicenaListaEvidencijaHeader
            title1={res.dozvoljenaTempMax}
            title2={res.dozvoljenaTempMin}
            title3={res.dozvoljenoOdstupanje}
            value1={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMax}
            value2={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMin}
            value3={data[0].RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje}
          />
        )}

        {recordField === EnumPoljaEvidencije.TemperaturaOgranicenaEvd_V1 && (
          <View style={styles.table}>
            <TableRowTemperaturaOgranicenaEvdListaEvidencijaHeader
              resdatum={res.datum}
              resfullname={res.imeIPrezime}
              resnapomena={res.napomena}
              respotpis={res.potpis}
              restackaPrimjene={res.tackaPrimjene}
              resocitanaTemperatura={res.ocitanaTemperatura}
              reszadovoljenaKontrola={res.zadovoljenaKontrola}
            />
            {convertedArray.map((item, index) => (
              <TableRowTemperaturaOgranicenaEvdListaEvidencija
                key={index}
                resda={res.da}
                resne={res.ne}
                datum={item.extraDatum ? item.extraDatum : ""}
                potpis={item.potpis}
                fullname={item.fullname}
                dozvoljenaTempMax={item.dozvoljenaTempMax}
                dozvoljenaTempMin={item.dozvoljenaTempMin}
                dozvoljenoOdstupanje={item.dozvoljenoOdstupanje}
                ocitanaTemperatura={item.ocitanaTemperatura}
                napomena={item.napomena}
                tackaPrimjene={item.naziv}
              />
            ))}
          </View>
        )}

        {/* Temperatura Ogranicena KKT Evd */}
        {recordField === EnumPoljaEvidencije.TemperaturaOgranicenaKKTEvd_V1 && (
          <TableTemperaturaOgranicenaKKTListaEvidencijaHeader
            title1={res.dozvoljenaTempMax}
            title2={res.dozvoljenaTempMin}
            title3={res.dozvoljenoOdstupanje}
            value1={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMax}
            value2={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMin}
            value3={data[0].RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje}
          />
        )}

        {recordField === EnumPoljaEvidencije.TemperaturaOgranicenaKKTEvd_V1 && (
          <View style={styles.table}>
            <TableRowTemperaturaOgranicenaKKTEvdListaEvidencijaHeader
              resdatum={res.datum}
              resfullname={res.imeIPrezime}
              resnapomena={res.napomena}
              respotpis={res.potpis}
              restackaPrimjene={res.tackaPrimjene}
              resocitanaTemperatura={res.ocitanaTemperatura}
              reszadovoljenaKontrola={res.zadovoljenaKontrola}
              reskorektivnaMjera={res.korektivnaMjera}
            />
            {convertedArray.map((item, index) => (
              <TableRowTemperaturaOgranicenaKKTEvdListaEvidencija
                key={index}
                resda={res.da}
                resne={res.ne}
                datum={item.extraDatum ? item.extraDatum : ""}
                potpis={item.potpis}
                fullname={item.fullname}
                dozvoljenaTempMax={item.dozvoljenaTempMax}
                dozvoljenaTempMin={item.dozvoljenaTempMin}
                dozvoljenoOdstupanje={item.dozvoljenoOdstupanje}
                ocitanaTemperatura={item.ocitanaTemperatura}
                napomena={item.napomena}
                tackaPrimjene={item.naziv}
                korektivnaMjera={item.adekvatnoPrikupljen}
              />
            ))}
          </View>
        )}

        {recordField === EnumPoljaEvidencije.TemperaturaKKTProizvodiEvd_V1 && (
          <TableTemperaturaOgranicenaKKTListaEvidencijaHeader
            title1={res.dozvoljenaTempMax}
            title2={res.dozvoljenaTempMin}
            title3={res.dozvoljenoOdstupanje}
            value1={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMax}
            value2={data[0].RecordTraceConfig?.tempConfig?.dozvoljenaTempMin}
            value3={data[0].RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje}
          />
        )}

        {recordField === EnumPoljaEvidencije.TemperaturaKKTProizvodiEvd_V1 && (
          <View style={styles.table}>
            <TableRowTemperaturaKKTProizvodiEvdListaEvidencijaHeader
              resdatum={res.datum}
              resfullname={res.imeIPrezime}
              resnapomena={res.napomena}
              respotpis={res.potpis}
              restackaPrimjene={res.tackaPrimjene}
              resocitanaTemperatura={res.ocitanaTemperatura}
              reszadovoljenaKontrola={res.zadovoljenaKontrola}
              reskorektivnaMjera={res.korektivnaMjera}
              resproizvod={res.proizvod}
            />
            {convertedArray.map((item, index) => (
              <TableRowTemperaturaKKTProizvodiEvdListaEvidencija
                key={index}
                resda={res.da}
                resne={res.ne}
                datum={item.extraDatum ? item.extraDatum : ""}
                potpis={item.potpis}
                fullname={item.fullname}
                dozvoljenaTempMax={item.dozvoljenaTempMax}
                dozvoljenaTempMin={item.dozvoljenaTempMin}
                dozvoljenoOdstupanje={item.dozvoljenoOdstupanje}
                ocitanaTemperatura={item.ocitanaTemperatura}
                napomena={item.napomena}
                tackaPrimjene={item.naziv}
                korektivnaMjera={item.adekvatnoPrikupljen}
                proizvod={item.proizvod}
              />
            ))}
          </View>
        )}

        {/* CIPP EVD */}
        {recordField === EnumPoljaEvidencije.CIPP_V1 && (
          <View style={styles.table}>
            <TableRowCIPPEvdListaEvidencijaHeader
              datum={res.datum}
              fullname={res.izvrsioc}
              potpis={res.potpis}
              naziv={res.naziv}
            />
            {convertedArray.map((item, index) => (
              <TableRowCIPPEvdListaEvidencija
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                potpis={item.potpis}
                naziv={item.naziv}
              />
            ))}
          </View>
        )}

        {/* OTPAD EVD */}
        {recordField === EnumPoljaEvidencije.OtpadEvd_V1 && (
          <View style={styles.table}>
            <TableRowOtpadEvdListaEvidencijaHeader
              datum={res.datum}
              fullname={res.otpadPredao}
              potpis={res.potpis}
              kolicina={res.kolicina}
              korektivnaMjera={res.otpadKorektivnaMjera}
              potpisPrimaoca={res.potpisPrimalac}
              primaoc={res.otpadPrimio}
              vrstaOtpada={res.vrstaOtpada}
              tackaEvidencije={res.tackaPrimjene}
              napomena={res.napomena}
            />
            {convertedArray.map((item, index) => (
              <TableRowOtpadEvdListaEvidencija
                key={index}
                datum={item.datum}
                potpis={item.potpis}
                fullname={item.fullname}
                jedinicaMjere={item.jedinicaMjere}
                kolicina={item.kolicina}
                korektivnaMjera={item.adekvatnoPrikupljen ? res.da : res.ne}
                potpisPrimaoca={item.potpisPrimalac}
                primaoc={item.primalac}
                vrstaOtpada={item.vrsta}
                tackaPrimjene={item.naziv}
                napomena={item.korektivnaMjera}
              />
            ))}
          </View>
        )}

        {/* CIPO EVD */}
        {recordField === EnumPoljaEvidencije.CIPO_V1 && (
          <View style={styles.table}>
            <TableRowCIPOEvdListaEvidencijaHeader
              datum={res.datum}
              fullname={res.izvrsioc}
              naziv={res.naziv}
              potpis={res.potpis}
              type={res.napomena}
            />
            {convertedArray.map((item, index) => (
              <TableRowCIPOEvdListaEvidencija
                key={index}
                datum={item.datum}
                fullname={item.fullname}
                naziv={item.naziv}
                potpis={item.potpis}
                type={item.tipEvidencije}
              />
            ))}
          </View>
        )}

        <TableFooterPdf
          resPotpis={res.potpisFooter}
          resKontrolisao={res.upisaoFooter}
          kontrolisao={person?.user.fullName}
          potpis={person?.user.potpis}
        />

        <PageNumber />
      </Page>
      <Page size="A4" orientation={PDFOrientation} style={styles.page}>
        <TableRichDescriptionPdf richDescription={richDescription} />
        <PageNumber />
      </Page>
    </Document>
  );
};

const sanitizePdfFilenamePart = (value: string): string =>
  value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9-_ ]+/g, "")
    .trim()
    .replace(/\s+/g, "-");

const buildZbirnaPdfFilename = (
  title: string,
  startDate: Date,
  endDate: Date,
): string => {
  const safeTitle = sanitizePdfFilenamePart(title) || "zbirna-evidencija";
  const datePart = `${formatDate(startDate.toString())}_${formatDate(
    endDate.toString(),
  )}`.replace(/\./g, "-");
  return `${safeTitle}_${datePart}.pdf`;
};

export const generatePDFList = async (
  data: IRecordPointClass[],
  branch: IPDFBranch,
  res: ITextFields,
  title: string,
  recordField: EnumPoljaEvidencije,
  startDate: Date,
  endDate: Date,
) => {
  const descriptionMarkdown = data[0];
  const richDescription = await getRichDescription(descriptionMarkdown);

  const blob = await pdf(
    <PdfDocument
      data={data}
      branch={branch}
      evidencija={res.evidencija}
      title={title}
      res={res}
      recordField={recordField}
      startDate={startDate}
      endDate={endDate}
      richDescription={richDescription}
    />,
  ).toBlob();

  // Desktop / wide screen: open in a new tab only. Never trigger Save-as.
  if (preferListaEvidencijaPdfInlineTab()) {
    openListaEvidencijaPdfBlobInNewTab(blob);
    return;
  }

  // Narrow viewports keep the explicit download.
  const url = URL.createObjectURL(
    blob.type === "application/pdf"
      ? blob
      : new Blob([blob], { type: "application/pdf" }),
  );
  const filename = buildZbirnaPdfFilename(title, startDate, endDate);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.rel = "noopener";
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    try {
      document.body.removeChild(link);
    } catch {
      // ignore
    }
    URL.revokeObjectURL(url);
  }, 1000);
};
